import { Injectable } from '@angular/core';
import { ApplicationConstantsResponse } from 'app/shared/_models/applicationConstantsResponse';
import { ServiceResponse } from 'app/shared/_models/serviceResponse';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { USER_EVENT_TYPE } from '../constants';
import { WrenchApiService } from './wrench-api.service';
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { EventTrackingService } from './event-tracking.service';
import { ProductIdConstants } from '../../shared/_models/productIdConstants';
import { CatalogEntryIdConstants } from '../../shared/_models/catalogEntryIdConstants';
import { SchedulingWindow } from 'app/scheduling-windows/models/scheduling-window';

@Injectable({
    providedIn: 'root'
})
export class ConstantsService extends WrenchApiService {

    PRODUCT_ID = new BehaviorSubject<ProductIdConstants>({} as ProductIdConstants);
    APP_CONSTANTS = new BehaviorSubject<ApplicationConstantsResponse>(new ApplicationConstantsResponse());
    CATALOG_ENTRY_ID: CatalogEntryIdConstants;
    PREAUTH_LIMIT: number;
    PREAUTH_ENABLED: boolean;
    PREAUTH_FLEET: boolean;
    ZIPCODE_LENGTH: number = 5;
    SCHEDULING_WINDOWS: SchedulingWindow[];

    constructor(
        protected http: HttpClient,
        protected authService: AuthService,
        protected router: Router,
        protected eventTrackingService: EventTrackingService) {

        super(http, authService, router, eventTrackingService);
    }
    /*
    * This service is to be initialized in app.component.ts so that the constants
    * persists across a session
     */
    init(): Observable<boolean> {
        return new Observable((observer: Observer<boolean>) => {
            this.getApplicationConstants().subscribe((response: ApplicationConstantsResponse) => {
                const appConstants = Object.assign( new ApplicationConstantsResponse(), response);
                this.updateProductIds(response.productIds);
                this.updateAppConstants(appConstants);
                this.CATALOG_ENTRY_ID = response.catalogEntryIds;
                this.PREAUTH_LIMIT = response.preauthLimit;
                this.PREAUTH_ENABLED = response.preauthEnabled;
                this.PREAUTH_FLEET = response.preauthFleet;
                this.ZIPCODE_LENGTH = response.zipLength ?? 5;
                this.SCHEDULING_WINDOWS = response.schedulingWindows;
                observer.next(true);
            }, (error: ServiceResponse) => {
                observer.next(false);
            });
        }
        );
    } // init()

    getProductIdObservable(): Observable<ProductIdConstants> {
        return this.PRODUCT_ID.asObservable();
    } // getProductIds()

    getProductIdValue(): ProductIdConstants {
        return this.PRODUCT_ID.getValue();
    } // getCurrentProductIds()

    updateProductIds(productId: ProductIdConstants): void {
        this.PRODUCT_ID.next(productId);
    } // updateProductIds()

    getAppConstants(): ApplicationConstantsResponse {
        return this.APP_CONSTANTS.getValue();
    } // getCurrentProductIds()

    updateAppConstants(appConstants: ApplicationConstantsResponse): void {
        this.APP_CONSTANTS.next(appConstants);
    } // updateProductIds()

    public isProductAddOnOC(productId: number): boolean {
        return productId == this.getProductIdValue().ADD_ON_OC || productId == this.getProductIdValue().FLEET_ADD_ON_OC;
    } // isProductAddOnOC()

    private getApplicationConstants(): Observable<ApplicationConstantsResponse> {
        return this.request('/user/getapplicationconstants', {}, 'constants-service', USER_EVENT_TYPE.GET_APPLICATION_CONSTANTS, true);
    } // getApplicationConstants()

    getSchedulingWindow(market: string): SchedulingWindow {
        return this.SCHEDULING_WINDOWS.find(w => w.market === market)
            || this.SCHEDULING_WINDOWS.find(w => w.market.toLowerCase() === 'default')
            || {} as SchedulingWindow;
    } // getSchedulingWindow()

}
